module.exports = __webpack_public_path__ + "img/52002742_L.20c73313.png";